// extracted by mini-css-extract-plugin
export var fullWidthButton = "_i6-0";